var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sdk-universal-config-manage-page" },
    [
      _c(
        "basic-container",
        [
          _c(
            "div",
            { staticClass: "search-form-wrap" },
            [
              _c(
                "el-form",
                {
                  staticClass: "demo-form-inline",
                  attrs: { size: "small", inline: true, model: _vm.formInline },
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "", placeholder: "配置分类" },
                          model: {
                            value: _vm.formInline.categoryCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.formInline, "categoryCode", $$v)
                            },
                            expression: "formInline.categoryCode",
                          },
                        },
                        _vm._l(_vm.sdkCategoryOptions, function (item) {
                          return _c("el-option", {
                            key: item.dictKey,
                            attrs: {
                              label: item.dictValue,
                              value: item.dictKey,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { clearable: "", placeholder: "配置名称/KEY" },
                        model: {
                          value: _vm.formInline.search,
                          callback: function ($$v) {
                            _vm.$set(_vm.formInline, "search", $$v)
                          },
                          expression: "formInline.search",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "auth",
                              rawName: "v-auth",
                              value: "APPS_SDK_UNIVERSAL_CONFIG_INDEX_SEARCH",
                              expression:
                                "'APPS_SDK_UNIVERSAL_CONFIG_INDEX_SEARCH'",
                            },
                          ],
                          attrs: { type: "primary" },
                          on: { click: _vm.handleSearch },
                        },
                        [_vm._v("搜索")]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "auth",
                              rawName: "v-auth",
                              value: "APPS_SDK_UNIVERSAL_CONFIG_INDEX_ADD",
                              expression:
                                "'APPS_SDK_UNIVERSAL_CONFIG_INDEX_ADD'",
                            },
                          ],
                          attrs: { type: "primary", plain: "" },
                          on: { click: _vm.openDialog },
                        },
                        [_vm._v("新增")]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "auth",
                              rawName: "v-auth",
                              value: "APPS_SDK_UNIVERSAL_CONFIG_INDEX_DEL",
                              expression:
                                "'APPS_SDK_UNIVERSAL_CONFIG_INDEX_DEL'",
                            },
                          ],
                          attrs: { type: "danger", plain: "" },
                          on: { click: _vm.handleDelete },
                        },
                        [_vm._v("删除")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("avue-crud", {
            ref: "crud",
            attrs: {
              option: _vm.option,
              page: _vm.page,
              "table-loading": _vm.loading,
              data: _vm.data,
            },
            on: {
              "update:page": function ($event) {
                _vm.page = $event
              },
              "on-load": _vm.getList,
              "selection-change": _vm.handleSelectionChange,
            },
            scopedSlots: _vm._u([
              {
                key: "menu",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "APPS_SDK_UNIVERSAL_CONFIG_INDEX_EDIT",
                            expression:
                              "'APPS_SDK_UNIVERSAL_CONFIG_INDEX_EDIT'",
                          },
                        ],
                        attrs: {
                          size: "small",
                          type: "text",
                          icon: "el-icon-edit",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(scope.row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "APPS_SDK_UNIVERSAL_CONFIG_INDEX_DEL",
                            expression: "'APPS_SDK_UNIVERSAL_CONFIG_INDEX_DEL'",
                          },
                        ],
                        attrs: {
                          size: "small",
                          type: "text",
                          icon: "el-icon-delete",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleDeleteRow(scope.row)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.isEdit ? "编辑" : "新增",
            "append-to-body": "",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            visible: _vm.visible,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            close: _vm.onDialogClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialog-content-wrap" },
            [
              _c(
                "el-form",
                {
                  ref: "editForm",
                  attrs: {
                    model: _vm.formModel,
                    rules: _vm.rules,
                    size: "small",
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "配置分类", prop: "categoryCode" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择配置分类" },
                          model: {
                            value: _vm.formModel.categoryCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.formModel, "categoryCode", $$v)
                            },
                            expression: "formModel.categoryCode",
                          },
                        },
                        _vm._l(_vm.sdkCategoryOptions, function (item) {
                          return _c("el-option", {
                            key: item.dictKey,
                            attrs: {
                              label: item.dictValue,
                              value: item.dictKey,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "配置名称", prop: "name" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.formModel.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.formModel, "name", $$v)
                          },
                          expression: "formModel.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "KEY值", prop: "code" } },
                    [
                      _c("el-input", {
                        attrs: { disabled: _vm.isEdit },
                        model: {
                          value: _vm.formModel.code,
                          callback: function ($$v) {
                            _vm.$set(_vm.formModel, "code", $$v)
                          },
                          expression: "formModel.code",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "数据类型", prop: "dataType" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            disabled: _vm.isEdit,
                            placeholder: "请选择数据类型",
                          },
                          model: {
                            value: _vm.formModel.dataType,
                            callback: function ($$v) {
                              _vm.$set(_vm.formModel, "dataType", $$v)
                            },
                            expression: "formModel.dataType",
                          },
                        },
                        _vm._l(_vm.dataTypeOptions, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "配置说明", prop: "dataDescr" } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea", rows: 4 },
                        model: {
                          value: _vm.formModel.dataDescr,
                          callback: function ($$v) {
                            _vm.$set(_vm.formModel, "dataDescr", $$v)
                          },
                          expression: "formModel.dataDescr",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "value示例", prop: "valueEx" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          maxlength: "999999",
                          "show-word-limit": "",
                          rows: 4,
                        },
                        model: {
                          value: _vm.formModel.valueEx,
                          callback: function ($$v) {
                            _vm.$set(_vm.formModel, "valueEx", $$v)
                          },
                          expression: "formModel.valueEx",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("LogDialog", { ref: "logDialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }